import { render, staticRenderFns } from "./NewViewBookings.vue?vue&type=template&id=30a7a962&scoped=true"
import script from "./NewViewBookings.vue?vue&type=script&lang=js"
export * from "./NewViewBookings.vue?vue&type=script&lang=js"
import style0 from "./NewViewBookings.vue?vue&type=style&index=0&id=30a7a962&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a7a962",
  null
  
)

export default component.exports